import { useQuery, useQueryClient } from "@tanstack/react-query";

import type { Tool } from "../core/domain/entities/tool";
import { useNavigationApi } from "../hooks";

export const allToolsQueryKey = ["navigation/organization/tools"];

const useQueryAccessibleTools = () => {
  const { api } = useNavigationApi();

  return useQuery<Tool[]>({
    queryKey: allToolsQueryKey,
    queryFn: () => api.navigation.getAccessibleTools(),
  });
};

export const useInvalidateAccessibleTools = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: allToolsQueryKey,
    });
};

export default useQueryAccessibleTools;
